import type { FC } from 'react';
import Box from '@mui/material/Box';
import UsersGrid from './UsersGrid';
import { FormProvider, useForm } from 'react-hook-form';
import type { z } from 'zod';
import FilterSearch from './FilterSearch';
import { SelectApplications } from 'components/common';
import { usersValidator } from '../validation';
import { useListParams } from 'hooks';

type FormData = z.infer<typeof usersValidator.schema>;

const Users: FC = () => {
  const { q, apps } = useListParams();
  const formMethod = useForm<FormData>({
    resolver: usersValidator.resolver,
    defaultValues: {
      q: q ?? undefined,
      apps: apps ? (apps as string[]) : undefined,
    },
  });

  return (
    <FormProvider {...formMethod}>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          height: '100%',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Box
          sx={{ display: 'flex', width: '100%', flexDirection: 'row', gap: 2 }}
        >
          <Box sx={{ flex: 2 }}>
            <FilterSearch name={'q'} placeholder={'Search by email'} />
          </Box>
          <Box sx={{ flex: 1 }}>
            <SelectApplications name={'apps'} inputLabel={'Apps'} multiples />
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flex: 1,
            width: '100%',
            height: '100%',
            position: 'relative',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              width: '100%',
              height: '100%',
            }}
          >
            <UsersGrid />
          </Box>
        </Box>
      </Box>
    </FormProvider>
  );
};

export default Users;
